import { DeleteIcon } from '@chakra-ui/icons';
import {
  Button,
  Flex,
  HStack,
  IconButton,
  Input,
  Select,
  Table, Tbody,
  Td,
  Th, Thead, Tr,
  VStack,
  useColorModeValue
} from '@chakra-ui/react';
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import { useEffect, useState } from 'react';
import JobsController from 'controllers/Jobs/JobsController';
import { useParams } from 'react-router-dom';

function MetaView() {
  const [data, setData] = useState([]);
  const [MetaName, setNewMetaName] = useState("");
  const [MetaDefaultFile, setNewMetaDefaultFile] = useState("");
  const [MetaFieldsExtract, setNewMetaFIeldsExtract] = useState("");
  const [newFileType, setNewMetaType] = useState("Selecione o tipo");
  const textColor = useColorModeValue("gray.700", "white");
  const { idtranscript_scheduller } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (idtranscript_scheduller) {
          console.log(idtranscript_scheduller);
          const response = await JobsController.GetMetadados(idtranscript_scheduller);
          setData(response);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [idtranscript_scheduller]);

  const AddMetadados = async () => {
    try {
      const concatenatedFileType = `${MetaDefaultFile}.${newFileType}`;

      const response = await JobsController.AddMetadados(MetaName, concatenatedFileType, newFileType, MetaFieldsExtract, idtranscript_scheduller);
      if (response) {
        const newUsuarios = await JobsController.GetMetadados(idtranscript_scheduller);
        setData(newUsuarios);
        setNewMetaName("");
        setNewMetaDefaultFile("");
        setNewMetaFIeldsExtract("");
        setNewMetaType("Selecione o tipo");
      }
    } catch (error) {
      console.error("Error adding meta:", error);
    }
  };

  return (
    <Flex direction='column' height={"100%"} width="100%">
      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <CardHeader>
          <VStack spacing={2} align="stretch">
            <HStack spacing={2}>
              <Input
                value={MetaName}
                onChange={(e) => setNewMetaName(e.target.value)}
                placeholder="Nome"
              />
              <Input
                value={MetaDefaultFile}
                onChange={(e) => setNewMetaDefaultFile(e.target.value)}
                placeholder="Padrão do arquivo"
              />
              <Input
                value={MetaFieldsExtract}
                onChange={(e) => setNewMetaFIeldsExtract(e.target.value)}
                placeholder="Campos a extrair"
              />
              <Select
                value={newFileType}
                onChange={(e) => setNewMetaType(e.target.value)}
                placeholder="Selecione o tipo"
              >
                <option value="csv">CSV</option>
                <option value="jpg">JPG</option>
                <option value="pdf">PDF</option>
              </Select>
              <Button onClick={AddMetadados} colorScheme="blue" width="auto" minWidth="200px">
                Adicionar
              </Button>
            </HStack>
          </VStack>
        </CardHeader>
        <CardBody>
          <Table variant='simple' color={textColor}>
            <Thead>
              <Tr color='gray.400'>
                <Th color={textColor}>NOME</Th>
                <Th color={textColor}>PADRÃO DO ARQUIVO</Th>
                <Th color={textColor}>DATA DE CRIAÇÃO</Th>
                <Th color={textColor}>TIPO</Th>
                <Th color={textColor}>CAMPOS A EXTRAIR</Th>
                <Th color={textColor}>AÇÕES</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data.map((meta) => (
                <MetaRow 
                  key={meta.id} 
                  meta={meta} 
                  setData={setData} 
                  idtranscript_scheduller={idtranscript_scheduller}
                />
              ))}
            </Tbody>
          </Table>
        </CardBody>
      </Card>
    </Flex>
  );
}

function MetaRow({ meta, setData, idtranscript_scheduller }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedLogin, setEditedLogin] = useState(meta.login);
  const [editedEmail, setEditedEmail] = useState(meta.email);
  const [editedFileType, setEditedFileType] = useState(meta.file_type);

  const deleteMeta = async () => {
    try {
      const response = await JobsController.DeleteMeta(meta.id);
      if (response) {
        const updatedUsuarios = await JobsController.GetMetadados(idtranscript_scheduller);
        setData(updatedUsuarios);
      }
    } catch (error) {
      console.error("Error deleting meta:", error);
    }
  };

  return (
    <Tr>
      <Td>
        {isEditing ? (
          <Input value={editedLogin} onChange={(e) => setEditedLogin(e.target.value)} />
        ) : (
          meta.meta_name
        )}
      </Td>
      <Td>
        {isEditing ? (
          <Input value={editedEmail} onChange={(e) => setEditedEmail(e.target.value)} />
        ) : (
          meta.default_file
        )}
      </Td>
      <Td>{meta.date_inserted}</Td>
      <Td>
        {isEditing ? (
          <Select
            value={editedFileType}
            onChange={(e) => setEditedFileType(e.target.value)}
          >
            <option value="csv">CSV</option>
            <option value="jpg">JPG</option>
            <option value="pdf">PDF</option>
          </Select>
        ) : (
          meta.type
        )}
      </Td>
      <Td>{meta.fields_to_extract}</Td>
      <Td>
        <IconButton icon={<DeleteIcon />} onClick={deleteMeta} />
      </Td>
    </Tr>
  );
}

export default MetaView;